import axiosInstance from './axiosConfig';

// Histogram data for a single metric (observations or plays)
export interface MetricHistogram {
  bins: number[];       // bin edges (log1p scale), length = N+1
  counts: number[];     // bin counts, length = N
  original_bins?: number[]; // original scale bin edges
  stats: {
    mean: number;
    median: number;
    p25: number;
    p75: number;
    total: number;
  };
}

// Population histogram data (inside `data` wrapper)
export interface PopulationHistogramData {
  media: string;
  available_media: string[];
  observations: MetricHistogram;
  plays: MetricHistogram;
}

// Full API response envelope
interface PopulationHistogramApiResponse {
  success: boolean;
  data: PopulationHistogramData;
}

/**
 * Fetch population histogram data for ad score distribution
 * @param media - Optional media type filter (e.g., "Instagram", "Facebook")
 */
export async function fetchPopulationHistogram(
  media?: string
): Promise<PopulationHistogramData> {
  const params: Record<string, string> = {};
  if (media) {
    params.media = media;
  }
  const response = await axiosInstance.get<PopulationHistogramApiResponse>(
    '/ad-score/population-histogram',
    { params }
  );
  return response.data.data;
}
